import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

let api = process.env.API_URL
let prefix = '/auth'

export default {
  get: {
    isLoggedIn () {
      return Vue.http.get(api + '/isLoggedIn')
    },
    confirmAccount (hash) {
      return Vue.http.get(api + prefix + '/account-confirmation/' + hash)
    }
  },
  post: {
    /**
     * Register.
     *
     * @return {Promise}
     */
    register (body) {
      return Vue.http.post(api + prefix + '/register', body)
    },
    /**
     * Login.
     *
     * @return {Promise}
     */
    login (body) {
      return Vue.http.post(api + prefix + '/login', body)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js